<template>
  <div class="nx-breadcrumbs">
    <div class="breadcrumbs" v-if="breadcrumbs" v-show="!loading">
      <div v-if="firstBreadcrumb.length > 0" class="nx-breadcrumbs-title">
        <router-link class="nx-breadcrumbs-link"
                     :to="entityRoute(firstBreadcrumb[0])" v-text="firstBreadcrumb[0].title">
        </router-link>
        <span class="nx-breadcrumbs-separator">/</span>
      </div>
      <v-menu v-if="middleBreadcrumbs" offset-y class="nx-breadcrumbs-dropdown">
        <template #activator="{ on: menu }">
          <v-tooltip bottom>
            <template #activator="{ on: tooltip }">
              <v-btn icon flat v-on="{ ...tooltip, ...menu }">
                <v-icon>more_horiz</v-icon>
              </v-btn>
              <span class="nx-breadcrumbs-separator">/</span>
            </template>
            <span>{{ $t("message.entity.breadcrumb.viewMore") }}</span>
          </v-tooltip>
        </template>
        <v-list>
          <v-list-tile
            v-for="(item, index) in middleBreadcrumbs"
            :key="index"
            :to="entityRoute(item)">
            <v-list-tile-title class="nx-breadcrumbs-sublink">
              <v-icon>folder</v-icon> {{ item.title }}
            </v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      <div v-if="lastBreadcrumb.length > 0" class="nx-breadcrumbs-title">
        <router-link class="nx-breadcrumbs-link" :to="entityRoute(lastBreadcrumb[0])" v-text="lastBreadcrumb[0].title">
        </router-link>
        <span class="nx-breadcrumbs-separator">/</span>
      </div>
      <v-icon v-if="icon && breadcrumbs.length > 0" small class="breadcrumb-ico">{{ icon }}</v-icon>
      <span class="nx-title" v-text="title"></span>
    </div>
    <span v-else class="nx-title" v-text="title" v-show="!loading"></span>
    <skeleton-loader v-show="loading" class="title ml-3" :width="200" :height="20" animation="fade"/>
  </div>
</template>

<script>
import SkeletonLoader from '@/components/skeleton/SkeletonLoader';

export default {
  name: 'nx-editor-title-breadcrumbs',
  components: {
    SkeletonLoader,
  },
  props: {
    breadcrumbs: {
      type: Array,
    },
    title: {
      type: String,
    },
    icon: {
      type: String,
    },
    tab: {
      type: String,
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    firstBreadcrumb() {
      if (this.$vuetify.breakpoint.xs) {
        return [];
      }
      return this.breadcrumbs.slice(0, 1);
    },
    middleBreadcrumbs() {
      if (this.$vuetify.breakpoint.xs) {
        return this.breadcrumbs;
      }
      if (this.breadcrumbs.length > 2) {
        return this.breadcrumbs.slice(1, this.breadcrumbs.length - 1);
      }
      return null;
    },
    lastBreadcrumb() {
      if (this.$vuetify.breakpoint.xs) {
        return [];
      }
      if (this.breadcrumbs.length > 1) {
        return this.breadcrumbs.slice(-1);
      }
      return [];
    },
  },
  methods: {
    entityRoute(breadcrumbItem) {
      if (breadcrumbItem.editorRoute) {
        if (this.tab) {
          breadcrumbItem.editorRoute.params.tab = this.tab; // Set current tab
        }
        return breadcrumbItem.editorRoute;
      }
      return breadcrumbItem.url;
    },
  },
};
</script>

<style lang="stylus">
.nx-breadcrumbs {
  display: inline;
  align-items: center;
  justify-content: flex-start;
  font-size: 18px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  .breadcrumbs {
    display: inline;
  }

  .skeleton-loader {
    display: inline-block;
    vertical-align: middle;
  }

  &-title {
    display: inline;
  }

  &-link{
    opacity: .6;
    text-decoration: none;
    display: inline;
    color: #A0A0AD;

    &:hover {
      color: #E9E9F2;
    }
  }

  &-separator {
    display: inline;
    margin: 0 10px;
  }

  &-sublink{
    text-decoration: none;
    font-size: 15px;

    .v-icon {
      margin: 0 20px 0 0;
    }
  }

  &-dropdown {
    display: inline;
  }

  .breadcrumb-ico {
    margin-right: 4px;
    margin-bottom: 2px;
  }
}
</style>
